import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import {
  ChartBar,
  ClipboardText,
  CurrencyCircleDollar,
  List,
  ShieldWarning,
  SignOut,
  Key,
  SquaresFour,
  UsersThree,
  UserGear,
  X,
} from "@phosphor-icons/react";
import { SelfPasswordDialog } from "./CredentialDialogs";

const adminNavigation = [
  ["/", "Dashboard", SquaresFour],
  ["/customers", "Customer", UsersThree],
  ["/collections", "Due Date", ClipboardText],
  ["/blacklist", "Blacklist", ShieldWarning],
  ["/reports", "Report", ChartBar],
  ["/team", "User", UserGear],
  ["/new-loans", "New Loan", CurrencyCircleDollar],
];

const officerNavigation = [
  ["/", "Dashboard", SquaresFour],
  ["/customers", "Customer", UsersThree],
  ["/collections", "Due Date", ClipboardText],
  ["/blacklist", "Blacklist", ShieldWarning],
  ["/reports", "Report", ChartBar],
  ["/new-loans", "New Loan", CurrencyCircleDollar],
];

export default function AppShell({ user, onSignOut, children }) {
  const [open, setOpen] = useState(false);
  const [passwordOpen, setPasswordOpen] = useState(false);
  const navigate = useNavigate();
  const signOut = async () => {
    await onSignOut();
    navigate("/login");
  };
  const navigation = ["admin", "master"].includes(user.role) ? adminNavigation : officerNavigation;

  return (
    <div className="app-shell" data-testid="application-shell">
      <button className="mobile-menu-button" onClick={() => setOpen(true)} data-testid="open-navigation-button" aria-label="Open navigation">
        <List size={24} weight="bold" />
      </button>
      <aside className={`sidebar ${open ? "is-open" : ""}`} data-testid="sidebar-navigation">
        <div className="brand-row">
          <Link to="/" className="brand" data-testid="brand-home-link"><span>CF</span> CrediFlow</Link>
          <button className="close-menu-button" onClick={() => setOpen(false)} data-testid="close-navigation-button" aria-label="Close navigation"><X size={22} /></button>
        </div>
        <div className="workspace-label" data-testid="workspace-label">Loan management</div>
        <nav>
          {navigation.map(([to, label, Icon]) => (
            <NavLink key={`${to}-${label}`} to={to} end={to === "/"} onClick={() => setOpen(false)} data-testid={`nav-${label.toLowerCase().replaceAll(" ", "-")}`}>
              <Icon size={20} weight="bold" />{label}
            </NavLink>
          ))}
        </nav>
        <div className="sidebar-user" data-testid="sidebar-user-info">
          <div className="user-avatar">{user.name.split(" ").map((item) => item[0]).slice(0, 2).join("")}</div>
          <div><strong data-testid="current-user-name">{user.name}</strong><span data-testid="current-user-role">{user.role}</span></div>
          <button onClick={() => setPasswordOpen(true)} title="Change password" data-testid="self-password-button" aria-label="Change password"><Key size={18} /></button><button onClick={signOut} title="Sign out" data-testid="sign-out-button" aria-label="Sign out"><SignOut size={20} /></button>
        </div>
      </aside>
      {open && <button className="mobile-overlay" onClick={() => setOpen(false)} data-testid="close-navigation-overlay" aria-label="Close navigation" />}
      <main className="main-content">{children}</main><SelfPasswordDialog open={passwordOpen} onClose={() => setPasswordOpen(false)} />
    </div>
  );
}